<template>
    <div>
        <small style="margin-block: 1rem; display: block; font-weight: 600;">Select Range</small>
        
        <DataTable @row-select="handleSelectionAdditionRanges($event)" class="site__table" :value="ranges" ref="ranges_table" :selection.sync="selectedRange">
            <template #empty>
                No ranges found.
            </template>
            <template #loading>
                Loading ranges. Please wait.
            </template>
            <Column selectionMode="single" headerClass="table__button--header" bodyClass="table__button"></Column>
            <Column field="label">
                <template #body="slotProps">
                    <span>{{ slotProps.data.label }}</span>
                </template>
            </Column>
        </DataTable>

        <div class="custom__range--wrapper" v-if="selectedRange && selectedRange.value === 'custom' && allowCustomRange">
            <small style="margin-block: 1rem; display: block; font-weight: 600;">Custom Range</small>
            <div class="p-d-flex p-ai-center" style="gap: 0.75rem; margin-top: 1rem;">
                <div class="p-d-flex p-ai-center" style="gap: 0.75rem;">
                    <span>Last</span>
                    <InputText @input="updateCustomRangeValue" v-model="selectedCustomRangeValue" class="frequency__input" type="number" />
                </div>

                <div class="report__detail--wrapper">
                    <Dropdown @change="updateCustomRangeInterval" v-model="selectedCustomRangeInterval" :options="customRangeIntervals" optionLabel="label"></Dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        allowCustomRange: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            ranges: [
                { label: 'Last 24 Hours', value: 'last_24_hours' },
                { label: 'Last 7 Days', value: 'last_7_days' },
                { label: 'Last Month', value: 'last_month' },
                { label: 'Last 6 Months', value: 'last_6_months' },
                ...(this.allowCustomRange ? [{ label: 'Custom', value: 'custom' }] : []),
            ],
            selectedRange: null,
            customRangeIntervals: [
                { label: 'Days', value: 'days' },
                { label: 'Weeks', value: 'weeks' },
                { label: 'Months', value: 'months' }
            ],
            selectedCustomRangeInterval: { label: 'Days', value: 'days' },
            selectedCustomRangeValue: null,
        }
    },
    mounted() {
        // setting defaults
        this.selectedRange = this.$store.getters['createCustomReport/getSelectedRange']
        const customRange = this.$store.getters['createCustomReport/getCustomRange']
        if (customRange) {
            this.selectedCustomRangeValue = customRange.value
            this.selectedCustomRangeInterval = this.customRangeIntervals.find(interval => interval.value === customRange.interval) || this.selectedCustomRangeInterval
        }
    },
    watch: {
        // watchers ensure the store value is shared between instances of the component
        selectedRangeFromStore: {
            handler(newVal) {
                this.selectedRange = newVal;
                if (newVal && newVal.value === 'custom') {
                    this.$nextTick(() => {
                        const dialogContent = document.querySelector('.p-dialog-content');
                        if (dialogContent) {
                            dialogContent.scrollTo({
                                top: dialogContent.scrollHeight,
                                behavior: 'smooth'
                            });
                        }
                    });
                }
            },
            immediate: true
        },
        customRange: {
            handler(newVal) {
                if (newVal) {
                    this.selectedCustomRangeValue = newVal.value;
                    this.selectedCustomRangeInterval = this.customRangeIntervals.find(interval => interval.value === newVal.interval) || this.selectedCustomRangeInterval;
                } else {
                    this.selectedCustomRangeValue = null;
                    this.selectedCustomRangeInterval = { label: 'Days', value: 'days' };
                }
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        selectedRangeFromStore() {
            return this.$store.getters['createCustomReport/getSelectedRange'];
        },
        customRange() {
            return this.$store.getters['createCustomReport/getCustomRange'];
        }
    },
    methods: {
        updateCustomRangeValue() {
            this.$store.dispatch('createCustomReport/setCustomRangeValue', this.selectedCustomRangeValue)
        },
        updateCustomRangeInterval() {
            this.$store.dispatch('createCustomReport/setCustomRangeInterval', this.selectedCustomRangeInterval.value)
        },
        handleSelectionAdditionRanges(event) {
            const range = event.data;
            this.$store.dispatch('createCustomReport/selectRange', range);
        }
    }
}
</script>

<style lang="scss" scoped>
.report__detail--label {
    font-size: 1.25rem;
    font-weight: 600;
}

.custom__range--wrapper {
    margin-block: 1rem;
}
</style> 